import React from 'react';
import type { Player } from '../services/api';

type MatrixData = {
  [key: string]: { [key: string]: number };
};

interface MatrixProps {
  title: string;
  matrixData: MatrixData;
  players: Player[];
}

const Matrix: React.FC<MatrixProps> = ({ title, matrixData, players }) => {
  if (players.length === 0) {
    return <div>No data to display for {title}</div>;
  }

  // Find the max value for color scaling
  let maxVal = 0;
  for (const p1 of players) {
    for (const p2 of players) {
      if (matrixData[p1.name] && matrixData[p1.name][p2.name] > maxVal) {
        maxVal = matrixData[p1.name][p2.name];
      }
    }
  }

  const getCellColor = (value: number) => {
    if (value === 0 || maxVal === 0) return '#ffffff'; // White for 0
    const opacity = Math.min(value / maxVal, 1.0);
    return `rgba(74, 144, 226, ${opacity})`; // Blue with variable opacity
  };

  const sortedPlayers = [...players].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div style={{ marginTop: '2rem' }}>
      <h3>{title}</h3>
      <table style={{ borderCollapse: 'collapse', fontSize: '0.8rem' }}>
        <thead>
          <tr>
            <th style={{ padding: '4px', border: '1px solid #ccc' }}></th>
            {sortedPlayers.map(p => <th key={p.id} style={{ padding: '4px', border: '1px solid #ccc', writingMode: 'vertical-rl', textOrientation: 'mixed' }}>{p.name}</th>)}
          </tr>
        </thead>
        <tbody>
          {sortedPlayers.map(p1 => (
            <tr key={p1.id}>
              <th style={{ padding: '4px', border: '1px solid #ccc', textAlign: 'left' }}>{p1.name}</th>
              {sortedPlayers.map(p2 => {
                if (p1.id === p2.id) {
                  return <td key={p2.id} style={{ padding: '4px', border: '1px solid #ccc', backgroundColor: '#e0e0e0' }}>-</td>;
                }
                const value = (matrixData[p1.name] && matrixData[p1.name][p2.name]) || 0;
                return (
                  <td key={p2.id} style={{ padding: '4px', border: '1px solid #ccc', textAlign: 'center', backgroundColor: getCellColor(value) }}>
                    {value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Matrix;
